import React, { useState } from 'react';
import Button from 'bizcap-web-components/dist/components/button';
import { BizonScreenWrapper, Title } from 'components/commons';
import Loading from 'components/loading';

import {
    DocumentType,
    useCompleteSignerChecklistItemMutation,
    useGenerateSignerDocumentToUploadAsyncMutation,
    DocumentOrigin
} from 'generated/credit-analysis-graphql';
import { ApolloClientName } from 'apollo-client-factory';

import Paragraph from 'components/commons/paragraph';
import CaptureSteps from './components/capture-steps/capture-steps';
import DocumentUploader from './components/document-uploader';
import PartnerDocumentCompleted from './components/partner-document-completed';
import useSignerDocumentInfo from './hooks/signer-document-info';
import './assets/css/documents-screen.styles.scss';

const PartnerDocumentForm: React.FC = (): JSX.Element => {
    const [submitEnabled, setSubmitEnabled] = useState(false);
    const [buttonLoading, setButtonLoading] = useState(false);
    const [documentSent, setDocumentSet] = useState(false);

    const [getSignedUrl] = useGenerateSignerDocumentToUploadAsyncMutation({
        context: { clientName: ApolloClientName.CreditAnalysisApi },
    });
    const [completeSignerChecklistItem] = useCompleteSignerChecklistItemMutation({
        context: { clientName: ApolloClientName.CreditAnalysisApi },
    });

    const {
        loading,
        signerName,
        applicantName,
        signerId,
        loanApplicationId,
        isCompleted,
    } = useSignerDocumentInfo();

    const handleSubmit = async () => {
        try {
            setButtonLoading(true);

            await completeSignerChecklistItem({
                variables: {
                    loanApplicationId,
                    signerId,
                    documentType: DocumentType.PartnerIdentity,
                }
            });

            setDocumentSet(true);
        } finally {
            setButtonLoading(false);
        }
    }

    if (loading) {
        return <Loading />;
    }

    if (documentSent || isCompleted) {
        return (
            <PartnerDocumentCompleted name={signerName.split(' ')[0]} />
        );
    }

    return (
        <BizonScreenWrapper>
            <form className="l-documents-screen grid-container" onSubmit={handleSubmit}>
                <div className="l-documents-screen__content">
                    <Title className="mb-4">
                        {signerName}, envie uma foto frente e verso da sua  identidade ou CNH
                    </Title>

                    <Paragraph className="ml-0 mr-0 mb-4">
                        <span className="bold">{applicantName}</span>, seu sócio, precisa que você envie seu documento de identificação pessoal (Identidade ou CNH) para continuar a analise de crédito na BizCapital.
                    </Paragraph>

                    <CaptureSteps />

                    <DocumentUploader
                        title="Enviar fotos agora"
                        className="mb-3"
                        filesLimit={2}
                        id="partner-document-form"
                        onUploadComplete={() => setSubmitEnabled(true)}
                        getSignedUrl={async (filename, contentType) => {
                            const { data } = await getSignedUrl({
                                variables: {
                                    loanApplicationId,
                                    signerId,
                                    documentType: DocumentType.PartnerIdentity,
                                    documentOrigin: DocumentOrigin.ThirdPart,
                                    contentType,
                                    filename
                                }
                            });

                            return data.generateSignerDocumentToUploadAsync;
                        }}
                    />

                    <br />
                </div>

                <div className="l-documents-screen__actions mt-4">
                    <div />
                    <Button
                        type="submit"
                        loading={buttonLoading}
                        onClick={handleSubmit}
                        disabled={!submitEnabled || buttonLoading}
                    >
                        salvar
                    </Button>
                </div>
            </form>
        </BizonScreenWrapper>
    );
};

export default PartnerDocumentForm;
